import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {routeNodeSelector, actions as routerActions} from 'redux-router5';
import PropTypes from 'prop-types';

import {alertActions, portalActions, userActions} from 'actions';

import {DictionaryContext} from 'Common/DictionaryContext';
import {Loading} from 'Common/Structure';
import {ErrorPage, ErrorBoundary} from 'Common/Error';

import NotFound from '../components/NotFound';
import CollectionForm from '../components/Payments/PaymentCollection/components/PaymentForm/CollectionForm';
import CompletePayment from '../components/Payments/PaymentCollection/components/PaymentForm/CompletePayment';
import PaymentCollection from '../components/Payments/PaymentCollection';
import AuthenticateToken from './AuthenticateToken';
import PayPalCallback from '../components/Payments/PaymentCollection/components/PayPalCallback';
import WePayCallback from '../components/Payments/PaymentCollection/components/WePayCallback';

const PaymentMain = props => {
  useEffect(
    () => {
      if (props.portalId) {
        props.loadPortal();
        props.loadPortalSettings();
      } else if (props.route.name !== 'authenticate') {
        props.loadGuestToken(props.route.params);
      }
    },
    [props.portalId],
  );

  useEffect(
    () => {
      if (props.errors.length > 0) {
        if (window.toastr !== undefined) {
          props.errors.forEach(error => {
            window.toastr.error(error);
          });
        }
        props.clearErrors();
      }
    },
    [props.errors],
  );

  useEffect(
    () => {
      if (props.successes.length > 0) {
        if (window.toastr !== undefined) {
          props.successes.forEach(success => {
            window.toastr.success(success);
          });
        }
        props.clearSuccesses();
      }
    },
    [props.successes],
  );

  let content;

  const {route} = props;
  const baseName = route.name.split('.')[0].toLowerCase();

  if (route.name === 'error') return <ErrorPage />;
  if (route.name === 'authenticate') return <AuthenticateToken />;

  if (props.tokenLoading || props.portalLoading) return <Loading />;

  switch (baseName) {
    case 'payment':
    case 'collectpayment':
    case 'completepayment':
      content =
        route.name === 'collectpayment' ? (
          <CollectionForm />
        ) : route.name === 'completepayment' ? (
          <CompletePayment />
        ) : (
          <PaymentCollection />
        );
      break;

    case 'paypalcallback':
      content = <PayPalCallback />;
      break;

    case 'wepaycallback':
      content = <WePayCallback />;
      break;

    default:
      content = <NotFound key="notFound" />;
      break;
  }

  return (
    <ErrorBoundary>
      <DictionaryContext.Provider value={props.dictionary}>
        {content}
      </DictionaryContext.Provider>
    </ErrorBoundary>
  );
};

PaymentMain.defaultProps = {
  route: {name: ''},
};

PaymentMain.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  route: PropTypes.shape({name: PropTypes.string.isRequired}),
  router: PropTypes.object.isRequired,
  successes: PropTypes.arrayOf(PropTypes.string).isRequired,

  // functions
  clearErrors: PropTypes.func.isRequired,
  clearSuccesses: PropTypes.func.isRequired,
  loadPortal: PropTypes.func.isRequired,
  loadPortalSettings: PropTypes.func.isRequired,
  loadGuestToken: PropTypes.func.isRequired,
  navigateTo: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    ...routeNodeSelector('')(state),
    errors: state.alerts.errors,
    router: state.router,
    successes: state.alerts.successes,
    portalId: state.user.tokenData.portal_id,
    tokenLoading: state.user.loading.token,
    portalLoading:
      state.portal.loadingPortalSettings || state.portal.portalInfo === {},
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearErrors: alertActions.clearErrors,
      clearSuccesses: alertActions.clearSuccesses,
      loadPortal: portalActions.loadPortal,
      loadPortalSettings: portalActions.loadPortalSettings,
      loadGuestToken: userActions.loadGuestToken,
      navigateTo: routerActions.navigateTo,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentMain);



// WEBPACK FOOTER //
// ./src/paymentApp/PaymentMain.js